import { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { useTenant } from "../../tenants/useTenant";
import { useLogin } from "./hooks/useLogin";

const Login = () => {
  const navigate = useNavigate();
  const tenant = useTenant();
  const {
    submit,
    loading,
    isBlocked,
    errorMessage,
    phase,
    otpEmail,
    otpLoading,
    otpError,
    resendOtp,
    verifyOtp,
  } = useLogin(
    tenant.hospitalId,
    () => navigate("/panel")
  );

  const LoginPage = tenant.login;

  return (
    <Suspense fallback={null}>
      <LoginPage
        onSubmit={submit}
        loading={loading}
        isBlocked={isBlocked}
        error={errorMessage}
        phase={phase}
        otpEmail={otpEmail}
        otpLoading={otpLoading}
        otpError={otpError}
        onVerifyOtp={verifyOtp}
        onResendOtp={resendOtp}
      />
    </Suspense>
  );
};

export default Login;
